import HTTP from "../config/axios";
const axios = new HTTP();
function getNewsList(type, currentPage) {
  return axios.get("/news/" + type + "/" + currentPage);
}

function getNewsDetail(id) {
  return axios.get("/news/" + id);
}

function getNewsHome() {
  return axios.get("/news/home");
}

function addMessage(data) {
  return axios.post("/message/leave", data);
}

export { getNewsList, getNewsDetail, getNewsHome, addMessage };
